import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from "@angular/forms";
import { PortService } from 'src/app/core-services/port.service';
import { VoyageDetailsModel } from 'src/app/models/VoyageDetailsModel';
import { SearchBy, UserRole, UserSelectedPlan, ShippingLineRroute } from 'src/app/Enum/Enum';
import { Port } from 'src/app/models/Port';
import { Transittime } from 'src/app/models/Transittime';
import { ActivatedRoute, Router } from '@angular/router';
import { QuickestSearchModel } from 'src/app/models/QuickestSearchModel';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { getLocaleMonthNames } from '@angular/common';
import { Paginator } from 'primeng/paginator';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AdminService } from 'src/app/public/landing/services/admin.service';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-trade-and-port-intelligence',
  templateUrl: './trade-and-port-intelligence.component.html',
  styleUrls: ['./trade-and-port-intelligence.component.scss']
})
export class TradeAndPortIntelligenceComponent implements OnInit {
  showloader: boolean = false;
  data: any;
  searchResult: any;
  hozizontaldata: any;
  optionsquick: any;
  options: any;
  portsData: Port[] = [];
  quckestsearchdata: any;
  chepestsearchdata: any;
  stateParams: any;
  logos: string[];
  shippingLines: any[];
  regions:any[];
  selectedRegion:any;
  selectedShipLines: any[] = [];
  shippingLineName: string[] = [];
  shippingIds: string;
  regionId: string;
  regionIds: string;
  Quickestserchres: QuickestSearchModel[] = [];
  chepestserchres: QuickestSearchModel[] = [];
  totalCount: number = 0;
  submitted: boolean = false;
  Val: number = 0;
  Optionsarr: any;
  dateRange: Date[] = [];
  depselectedDate: Date[] = [];
  minDate: Date;
  rageYears: string;
  valueArrival: number;
  valueDep: number;
  arroption: Options = {};
  OptionsDep: Options = {};
  IsFilter: boolean = false;
  toportarrivalladd30days: Date;
  fromportarrivaladd30days: Date;
  fromPortSliderSelectedDate: string;
  toPortSliderSelectedDate: string;
  selectedShipIds: number[] = [];
  transhipmentPorts: any[] = [];
  selectedTranshipmentPort: any;
  filterFlag: number;
  port: number;
  region: number;
  //cheapest: number;
  currentPage: number;
  pageSize: number;
  timeFlag: boolean = false;
  departurePortName: string;
  arrivalPortName: string;
  newDate: string;
  isSignedIn: boolean = false;
  planText: string;
  isPermission: boolean = false;
  totalSearchCount: number = 0;
  isBasicPlan: boolean = false;
  isSearch: boolean = true;
  currentUserDetails: any;
  userDetailsId: number = 0;
  scheduleRroute: number = 0;
  tap: number = SearchBy.Region;


  searchForm = this.fb.group<{
    fromPort: FormControl<string>;
    toPort: FormControl<string>;
    date: FormControl<string>;
  }>({
    fromPort: this.fb.control(''),
    toPort: this.fb.control(''),
    date: this.fb.control('')
  });

  constructor(private fb: FormBuilder, private portService: PortService, private adminService:AdminService,
     private activatedRoute: ActivatedRoute, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService) {
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.stateParams = params.params;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });

    var currentUser = localStorage.getItem('currentUser');
    if (currentUser != null && currentUser != undefined) {
      this.isSignedIn = true;
      this.currentUserDetails = JSON.parse(currentUser);
      if (this.currentUserDetails != null && this.currentUserDetails.usersDetailsVM != null && (this.currentUserDetails.usersDetailsVM.userRole != null && this.currentUserDetails.usersDetailsVM.userRole != '')) {
        if (this.currentUserDetails.usersDetailsVM.userRole == UserRole.User) {
          if (this.currentUserDetails.usersDetailsVM.planId != null && this.currentUserDetails.usersDetailsVM.planId == UserSelectedPlan.Basic) {
            this.isPermission = true;
            this.totalSearchCount = this.currentUserDetails.usersDetailsVM.totalSearchCount;
            this.isBasicPlan = true;
            this.userDetailsId = this.currentUserDetails.usersDetailsVM.id;
          }
        }
      }
    }
    else {
      this.userDetailsId = 0;
    }
  }
  @ViewChild('p') paginator: Paginator;

  ngOnInit() {
    this.currentPage = 1;
    this.pageSize = 5;
    this.filterFlag = SearchBy.Region;
    this.port = SearchBy.Port;
    this.region = SearchBy.Region;
    //this.cheapest = SearchBy.Cheapest;
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);

    var date = new Date(this.stateParams.date);
    var numberOfDaysToAdd = 31;
    var newdate = date.setDate(date.getDate() + numberOfDaysToAdd);
    this.newDate = this.dateConvert(newdate);

    if (this.stateParams.date != null) {
      // create Departure Slider
      this.createSliderForDeparture(this.stateParams.date);
      // create Departure Slider
      this.createSliderForArrival(this.newDate);
    }
    this.getRegions();
    this.getPortsData();
    this.getShippingLines();    
    this.getSearchResult();
    this.gettransittimedetails();
  }
  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  getTabDetails(flag) {
    this.selectedShipLines = [];
    this.tap = flag;
    this.shippingIds = '';
    this.timeFlag = false;
    // create Departure Slider
    this.createSliderForDeparture(this.stateParams.date);
    // create Departure Slider
    this.createSliderForArrival(this.newDate);
    if (flag == SearchBy.Port) {
      this.currentPage = 1;
      this.isSearch = false;
      this.SortByPortDetails();
    }
    // else if (flag == SearchBy.Cheapest) {
    //   this.currentPage = 1;
    //   this.isSearch = false;
    //   this.SortbyChepestDetails();
    // }
    else {
      this.currentPage = 1;
      this.isSearch = false;
      this.getSearchResult();
    }
  }

  gettransittimedetails() {
    var transit = new Transittime();
    //transit.FromPortId = 6057;//parseInt(this.stateParams.fromPortId);
    //transit.ToPortId = 13247;//parseInt(this.stateParams.toPortId);
    transit.fromdate = "2020-07-01";//this.stateParams.date;
    transit.Transhipment = this.scheduleRroute;
    this.spinner.show();
    this.portService.GetTransitTimeDate(transit).subscribe((response: any) => {
      if (response != null && response.content != null) {
        // this.showloader = false;
        let res = response.content;
        this.data = {
        showInLegend: true,
          labels: res.lable,
          lableshov: res.lablehov,
          datasets: [
            {
              lablesfortip: res.voyageNameList,
              eta: res.eta,
              dep: res.dep,
              ves: res.vesselsName,
              label: 'Transit Time',
              backgroundColor: '#6DCFD1',
              borderColor: '#1E88E5',
              data: res.days,
             }
          ],
        },        
        this.options = {
          responsive: true,
          legend: {
            itemStyle: {
              width: 3 // or whatever, auto-wrap
          },
            position: 'bottom',
            itemWrap: true
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                gridLines: {
                  display: false,
                },
              },
              ticks: {
                fontColor: "", // this here
              },
            }],
            yAxes: [{
              display: false,
              gridLines: {
                display: false,
              },
              ticks: {
                callback: function(label) {
                  if (/\s/.test(label)) {
                    return label.split(" ");
                  }else{
                    return label;
                  }              
                }
              }
            }],
          },
          tooltips: {
            callbacks: {
              title: function (tooltipItem, data) {
                return [data.lableshov[tooltipItem[0].index]];
              },
              label: function (tooltipItem, data) {
                // tooltipItem.xLabel = "ss";
                tooltipItem.label = data.lableshov[tooltipItem.index];
                var label = data.datasets[tooltipItem.datasetIndex].label || '';
                label += ': ' + Math.round(tooltipItem.yLabel) + ' Days';
                //var value1 = data.datasets[tooltipItem.datasetIndex].lablesfortip[tooltipItem.index];
                var eta = 'Arrival ' + data.datasets[tooltipItem.datasetIndex].eta[tooltipItem.index];
                var ED = 'Departure ' + data.datasets[tooltipItem.datasetIndex].dep[tooltipItem.index];
                var vesselsName = 'Vessel: ' + data.datasets[tooltipItem.datasetIndex].ves[tooltipItem.index];
                return [label, vesselsName, ED, eta];
              }
            }
          },
         animation: {
          duration: 500,
          easing: "easeOutQuart",
          onComplete: function () {
              var ctx = this.chart.ctx;
              //ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontFamily, 'normal', Chart.defaults.global.defaultFontFamily);
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';

              this.data.datasets.forEach(function (dataset) {
                  for (var i = 0; i < dataset.data.length; i++) {
                      var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                          scale_max = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._yScale.min;
                      ctx.fillStyle = '#444';
                      var y_pos = model.y - 5;
                      // Note: The y value is reverse, it counts from top down
                      if ((scale_max - model.y) / scale_max >= 0.93)
                          y_pos = model.y; 
                      //ctx.fillText(dataset.data[i], model.x, y_pos);
                      if(dataset.data[i]==0){
                        ctx.fillText("", model.x, 130);
                      }
                      else
                     // ctx.fillText(dataset.data[i]+' Days', model.x, 130);                     
                      ctx.fillText(dataset.data[i]+'', model.x, 110);
                      if(dataset.data[i] > 0){
                        ctx.fillText('Days', model.x, 125);
                      }                      
                  }
              });               
          }
      },	                
        };
      }
      this.spinner.hide();
    })
  }


  searchPorts(event, flag) {
    let portName = '';
    if (event != null && event.query != null && event.query != '') {
      if (event.query.length > 2) {
        portName = event.query;
      }
      else {
        this.portsData = [];
      }
    }
    else {
      if (flag == 'from') {
        if (this.searchForm.controls.fromPort.value != null && this.searchForm.controls.fromPort.value != '') {
          portName = (this.searchForm.controls.fromPort.value as any)?.portName;
        }
      }
      else {
        if (this.searchForm.controls.toPort.value != null && this.searchForm.controls.toPort.value != '') {
          portName = (this.searchForm.controls.toPort.value as any)?.portName;
        }
      }
    }
    if (event.query != '') {
      var data = {
        PortName: portName
      };
      this.portService.GetPortDataByName(data).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.portsData = response.content;
        }
        else {
          this.portsData = [];
        }
      })
    }
    else {
      this.getPortDatafordropdown();

    }
  }

  getSearchResult() {
    if (this.stateParams != null && this.stateParams != undefined) {
      var searchdata = new VoyageDetailsModel();
      searchdata.searchBy = 1;//SearchBy.Region;
      searchdata.pageNo = this.currentPage;
      searchdata.recPerPage = this.pageSize;
      searchdata.fromPortId = 6057;//parseInt(this.stateParams.fromPortId);
      searchdata.toPortId = 13247;//parseInt(this.stateParams.toPortId);
      searchdata.isBasicSearch = (this.isSearch == true && this.isBasicPlan == true) ? this.stateParams.isSearch : 'false';
      searchdata.userDetailsId = this.userDetailsId;
      searchdata.transhipment = this.scheduleRroute;
      searchdata.midPortId = this.selectedTranshipmentPort != null ? this.selectedTranshipmentPort.midPortId : 0;
      if (this.timeFlag == true) {
        searchdata.searchDate = this.fromPortSliderSelectedDate;
        searchdata.toPortArrivalDate = this.toPortSliderSelectedDate;
      }
      else {
        searchdata.searchDate = this.stateParams.date;
        searchdata.toPortArrivalDate = '';
      }

      searchdata.ShippingLineIds = (this.shippingIds == '' || this.shippingIds == null) ? '' : this.shippingIds;
      this.spinner.show();
      this.portService.SearchVoyages(searchdata,false).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.quckestsearchdata = response.content.contents;
          this.searchResult = response.content.contents;
          if (response.content.contents != null && response.content.contents.length > 0) {

            // this.createSliderForArrival(this.searchResult[0].toPortArrivalDate);
            if (this.timeFlag != true) {
              this.createSliderForArrival(this.searchResult[0].toPortArrivalDate);
              // this.GetSliderarrivalandDep(this.fromPortSliderSelectedDate, this.searchResult[0].toPortArrivalDate);
            }
            else {
              // this.GetSliderarrivalandDep(this.searchResult[0].fromPortArrivalDate, this.searchResult[0].toPortArrivalDate);
            }
          }
          this.totalCount = response.content.totalCount;
          this.selectedShipIds = [];


          if (searchdata.ShippingLineIds == null || searchdata.ShippingLineIds == '') {
            if (response.content.shippingLineIds != null && response.content.shippingLineIds.length > 0) {
              response.content.shippingLineIds.forEach(element => {
                var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
                this.selectedShipIds.push(element.shippingLineId);
              });
            }
          }
          else {
            var shipIds = searchdata.ShippingLineIds.split(',');
            if (shipIds != null) {
              for (var i = 0; i < shipIds.length; i++) {
                this.selectedShipIds.push(parseInt(shipIds[i]));
              }
            }
          }
          this.selectedShipLines = this.shippingLines.filter(x => this.selectedShipIds.includes(x.shippingLineId));

          // Transhipment Port filter
          if (this.scheduleRroute == ShippingLineRroute.Transhipment) {
            if (this.selectedTranshipmentPort == null) {
              if (response.content.transhipmentPorts != null && response.content.transhipmentPorts.length > 0) {
                this.transhipmentPorts = response.content.transhipmentPorts;
              }
            }
          }
          else {
            this.transhipmentPorts = [];
            this.selectedTranshipmentPort = null;
          }


        }
        this.spinner.hide();
      })
    }
  }

  SortByPortDetails() {
    if (this.stateParams != null && this.stateParams != undefined) {
      var searchdata = new VoyageDetailsModel();
      searchdata.searchBy = SearchBy.Port;
      this.filterFlag = SearchBy.Port;
      searchdata.pageNo = this.currentPage;
      searchdata.recPerPage = this.pageSize;
      searchdata.fromPortId = 6057;//parseInt(this.stateParams.fromPortId);
      searchdata.toPortId = 13247;//parseInt(this.stateParams.toPortId);
      searchdata.transhipment = this.scheduleRroute;
      searchdata.midPortId = this.selectedTranshipmentPort != null ? this.selectedTranshipmentPort.midPortId : 0;
      //searchdata.midPortId = this.selectedTranshipmentPort.midPortId
      if (this.timeFlag == true) {
        searchdata.searchDate = this.fromPortSliderSelectedDate;
        searchdata.toPortArrivalDate = this.toPortSliderSelectedDate;
      }
      else {
        searchdata.searchDate = this.stateParams.date;
        searchdata.toPortArrivalDate = '';
      }

      searchdata.ShippingLineIds = (this.shippingIds == '' || this.shippingIds == null) ? '' : this.shippingIds;
      this.spinner.show();
      this.portService.SearchVoyages(searchdata,false).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.quckestsearchdata = response.content.contents;
          this.searchResult = response.content.contents;
          this.spinner.hide();
          if (this.searchResult != null) {
            // this.GetSliderarrivalandDep(this.searchResult[0].fromPortArrivalDate, this.searchResult[0].toPortArrivalDate);

          }
          this.totalCount = response.content.totalCount;
          this.selectedShipIds = [];
          if (searchdata.ShippingLineIds == null || searchdata.ShippingLineIds == '') {
            if (response.content.shippingLineIds != null && response.content.shippingLineIds.length > 0) {
              response.content.shippingLineIds.forEach(element => {
                var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
                this.selectedShipIds.push(element.shippingLineId);
              });
            }

            // response.content.contents.forEach(element => {
            //   var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
            //   if (shippingdata != null) {
            //     this.selectedShipIds.push(element.shippingLineId);
            //   }
            // });
          }
          else {
            var shipIds = searchdata.ShippingLineIds.split(',');
            if (shipIds != null) {
              for (var i = 0; i < shipIds.length; i++) {
                this.selectedShipIds.push(parseInt(shipIds[i]));
              }
            }
          }
          this.selectedShipLines = this.shippingLines.filter(x => this.selectedShipIds.includes(x.shippingLineId));

          // Transhipment Port filter
          if (this.scheduleRroute == ShippingLineRroute.Transhipment) {
            if (this.selectedTranshipmentPort == null) {
              if (response.content.transhipmentPorts != null && response.content.transhipmentPorts.length > 0) {
                this.transhipmentPorts = response.content.transhipmentPorts;
              }
            }
          }
          else {
            this.transhipmentPorts = [];
            this.selectedTranshipmentPort = null;
          }

          this.Quickestserchres = [];
          this.quckestsearchdata.forEach(obj => {
            let quick: QuickestSearchModel = {};
            quick.LogoUrl = obj.companyLogo === null ? "" : obj.companyLogo;
            quick.voyageId = obj.id;
            quick.vesselsId = obj.vesselsId;
            quick.fromPortDepartureDate = this.dateConvert(obj.fromPortArrivalDate);
            quick.toPortArrivalDate = this.dateConvert(obj.toPortArrivalDate);
            quick.toCompanyLogo = obj.toCompanyLogo;
            quick.isTranshipment = obj.isTranshipment;
            quick.vesselsName = obj.vesselsName;
            quick.fromPortName = obj.fromPortName;
            quick.toPortName = obj.toPortName;
            quick.midPortName = obj.midPortName;
            quick.midPortArrivalDate = this.dateConvert(obj.midPortArrivalDate);
            quick.midPortDepartureDate = this.dateConvert(obj.midPortDepartureDate);
            quick.toVesselsName = obj.toVesselsName;
            quick.midPortId = obj.midPortId;
            quick.toVesselsId = obj.toVesselsId;
            quick.shippingLineId = obj.shippingLineId;

            let lables = [];
            let DataDay = [];
            let DataRate = [];
            lables.push(obj.vesselsName);
            DataDay.push(obj.noOfDays);
            obj.cubicMeter = obj.cubicMeter == null ? 0 : obj.cubicMeter;
            DataRate.push(obj.cubicMeter);
            let dis = {
              labels: lables,
              datasets: [
                {
                  label: 'Days',
                  data: DataDay,
                  backgroundColor: '#6DCFD1',
                },
                {
                  label: 'Rate',
                  data: DataRate,
                  backgroundColor: '#1F232A',
                }
              ],
            }
            quick.quickestdata = dis;
            this.Quickestserchres.push(quick);
            //this.logos.push(obj.companyLogo);
          });

          this.optionsquick = {
            legend: {
              position: 'bottom'
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: true,
                  gridLines: {
                    display: true,
                  },
                },
                ticks: {
                  beginAtZero: true,
                  // max: 100
                }
              }],
              yAxes: [{
                display: false,
                gridLines: {
                  display: false,
                }
              }
              ],
            }
          };
        }
        this.spinner.hide();
      })
    }
  }

  // SortbyChepestDetails() {
  //   if (this.stateParams != null && this.stateParams != undefined) {
  //     var searchdata = new IdViewModel();
  //     searchdata.searchBy = SearchBy.Cheapest;
  //     this.filterFlag = SearchBy.Cheapest;
  //     searchdata.pageNo = this.currentPage;
  //     searchdata.recPerPage = this.pageSize;
  //     searchdata.fromPortId = parseInt(this.stateParams.fromPortId);
  //     searchdata.toPortId = parseInt(this.stateParams.toPortId);
  //     searchdata.transhipment = this.scheduleRroute;
  //     searchdata.midPortId = this.selectedTranshipmentPort != null ? this.selectedTranshipmentPort.midPortId : 0;
  //     if (this.timeFlag == true) {
  //       searchdata.searchDate = this.fromPortSliderSelectedDate;
  //       searchdata.toPortArrivalDate = this.toPortSliderSelectedDate;
  //     }
  //     else {
  //       searchdata.searchDate = this.stateParams.date;
  //       searchdata.toPortArrivalDate = '';
  //     }

  //     searchdata.ShippingLineIds = (this.shippingIds == '' || this.shippingIds == null) ? '' : this.shippingIds;
  //     this.spinner.show();
  //     this.portService.SearchVoyages(searchdata).subscribe((response: any) => {
  //       if (response != null && response.content != null) {
  //         this.chepestsearchdata = response.content.contents;
  //         this.searchResult = response.content.contents;
  //         this.spinner.hide();
  //         if (this.searchResult != null) {
  //           // this.GetSliderarrivalandDep(this.searchResult[0].fromPortArrivalDate, this.searchResult[0].toPortArrivalDate);

  //         }
  //         this.totalCount = response.content.totalCount;
  //         this.selectedShipIds = [];
  //         if (searchdata.ShippingLineIds == null || searchdata.ShippingLineIds == '') {
  //           if (response.content.shippingLineIds != null && response.content.shippingLineIds.length > 0) {
  //             response.content.shippingLineIds.forEach(element => {
  //               var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
  //               this.selectedShipIds.push(element.shippingLineId);
  //             });
  //           }

  //           // response.content.contents.forEach(element => {
  //           //   var shippingdata = this.shippingLines.filter(x => x.shippingLineId == element.shippingLineId);
  //           //   if (shippingdata != null) {
  //           //     this.selectedShipIds.push(element.shippingLineId);
  //           //   }
  //           // });
  //         }
  //         else {
  //           var shipIds = searchdata.ShippingLineIds.split(',');
  //           if (shipIds != null) {
  //             for (var i = 0; i < shipIds.length; i++) {
  //               this.selectedShipIds.push(parseInt(shipIds[i]));
  //             }
  //           }
  //         }
  //         this.selectedShipLines = this.shippingLines.filter(x => this.selectedShipIds.includes(x.shippingLineId));

  //         // Transhipment Port filter
  //         if (this.scheduleRroute == ShippingLineRroute.Transhipment) {
  //           if (this.selectedTranshipmentPort == null) {
  //             if (response.content.transhipmentPorts != null && response.content.transhipmentPorts.length > 0) {
  //               this.transhipmentPorts = response.content.transhipmentPorts;
  //             }
  //           }
  //         }
  //         else {
  //           this.transhipmentPorts = [];
  //           this.selectedTranshipmentPort = null;
  //         }

  //         this.chepestserchres = [];
  //         this.chepestsearchdata.forEach(obj => {
  //           let quick: QuickestSearchModel = {};
  //           quick.LogoUrl = obj.companyLogo === null ? "" : obj.companyLogo;
  //           quick.voyageId = obj.id;
  //           quick.vesselsId = obj.vesselsId;
  //           quick.fromPortDepartureDate = this.dateConvert(obj.fromPortArrivalDate);
  //           quick.toPortArrivalDate = this.dateConvert(obj.toPortArrivalDate);
  //           quick.toCompanyLogo = obj.toCompanyLogo;
  //           quick.isTranshipment = obj.isTranshipment;
  //           quick.vesselsName = obj.vesselsName;
  //           quick.fromPortName = obj.fromPortName;
  //           quick.toPortName = obj.toPortName;
  //           quick.midPortName = obj.midPortName;
  //           quick.midPortArrivalDate = this.dateConvert(obj.midPortArrivalDate);
  //           quick.midPortDepartureDate = this.dateConvert(obj.midPortDepartureDate);
  //           quick.toVesselsName = obj.toVesselsName;
  //           quick.midPortId = obj.midPortId;
  //           quick.toVesselsId = obj.toVesselsId;
  //           let lables = [];
  //           let DataDay = [];
  //           let DataRate = [];
  //           lables.push(obj.vesselsName);
  //           DataDay.push(obj.noOfDays);
  //           DataRate.push(obj.cubicMeter);
  //           let dis = {
  //             labels: lables,
  //             datasets: [
  //               {
  //                 label: 'Days',
  //                 data: DataDay,
  //                 backgroundColor: '#6DCFD1',
  //               },
  //               {
  //                 label: 'Rate',
  //                 data: DataRate,
  //                 backgroundColor: '#1F232A',
  //               }
  //             ],
  //           }
  //           quick.quickestdata = dis;
  //           this.chepestserchres.push(quick);
  //           //this.logos.push(obj.companyLogo);
  //         });

  //         this.optionsquick = {
  //           legend: {
  //             position: 'bottom'
  //           },
  //           scales: {
  //             xAxes: [{
  //               gridLines: {
  //                 display: true,
  //                 gridLines: {
  //                   display: true,
  //                 },
  //               },
  //               ticks: {
  //                 beginAtZero: true,
  //                 // max: 100
  //               }
  //             }],
  //             yAxes: [{
  //               display: false,
  //               gridLines: {
  //                 display: false,
  //               }
  //             }
  //             ],
  //           }
  //         };
  //       }
  //       this.spinner.hide();
  //     })
  //   }
  // }


  getPortsData() {
    if (this.stateParams != null && this.stateParams != undefined) {
      var searchdata = new VoyageDetailsModel();
      searchdata.fromPortId = 6057;//parseInt(this.stateParams.fromPortId);
      searchdata.toPortId = 13247;//parseInt(this.stateParams.toPortId);
      this.portService.GetPortdata(searchdata).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.portsData = response.content;

          response.content.forEach(element => {
            if (element.id == this.stateParams.fromPortId) {
              this.searchForm.controls.fromPort.setValue(element);
              this.departurePortName = element.portName;
            }
            if (element.id == this.stateParams.toPortId) {
              this.searchForm.controls.toPort.setValue(element);
              this.arrivalPortName = element.portName;
            }
          });
          let newDate:any = new Date(this.stateParams.date);
          this.searchForm.controls.date.setValue(newDate);
        }
      });
    }
  }

  getShippingLines() {
    this.portService.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippingLines = response.content;
      }
    })
  }

  getRegions(){
    this.adminService.getRegions().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.regions = response.content;
      }
    })
  }

  onChangeRegion() {
    if (this.selectedRegion != null && this.selectedRegion != undefined && this.selectedRegion.id > 0) {
      this.regionId=this.selectedRegion.id;
    }
    else {
      this.selectedRegion.id;
    }
  }

  getSelectedRegion(event) {
    this.selectedRegion = [];
    if (event.value != null) {
      this.selectedRegion = event.value;
      this.regionIds = '';
      if (this.selectedRegion != null && this.selectedRegion.length > 0) {
        this.selectedRegion.forEach(element => {
          if (this.regionIds == '') {
            this.regionIds = element.shippingLineId.toString();
          }
          else {
            this.regionIds = this.regionIds + ',' + element.shippingLineId;
          }
        });
      }
      if (this.filterFlag == SearchBy.Port) {
        this.SortByPortDetails();
      }
      // else if (this.filterFlag == SearchBy.Cheapest) {
      //   this.currentPage = 1;
      //   this.isSearch = false;
      //   this.SortbyChepestDetails();
      // }
      else {
        this.currentPage = 1;
        this.isSearch = false;
        this.getSearchResult();
      }
    }
  }


  getSelectedShippingLine(event) {
    this.selectedShipLines = [];
    if (event.value != null) {
      this.selectedShipLines = event.value;
      this.shippingIds = '';
      if (this.selectedShipLines != null && this.selectedShipLines.length > 0) {
        this.selectedShipLines.forEach(element => {
          if (this.shippingIds == '') {
            this.shippingIds = element.shippingLineId.toString();
          }
          else {
            this.shippingIds = this.shippingIds + ',' + element.shippingLineId;
          }
        });
      }
      if (this.filterFlag == SearchBy.Port) {
        this.SortByPortDetails();
      }
      // else if (this.filterFlag == SearchBy.Cheapest) {
      //   this.currentPage = 1;
      //   this.isSearch = false;
      //   this.SortbyChepestDetails();
      // }
      else {
        this.currentPage = 1;
        this.isSearch = false;
        this.getSearchResult();
      }

    }

  }

  onSearch() {
    this.submitted = true;

    this.timeFlag = false;
    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }
    else {

      let data: any = this.searchForm.value;
      if (data != null && (data.fromPort != null && data.fromPort != '') && (data.toPort != null && data.toPort != '')) {
        if (this.isBasicPlan == true) {
          this.isSearch = true;
          this.totalSearchCount = (this.totalSearchCount != null && this.totalSearchCount > 0) ? this.totalSearchCount : 0
          this.totalSearchCount = this.totalSearchCount + 1;
          this.currentUserDetails.usersDetailsVM.totalSearchCount = this.totalSearchCount;
          localStorage.setItem("currentUser", JSON.stringify(this.currentUserDetails));
        }


        let date = this.dateConvert(this.searchForm.value.date);
        if (data.fromPort.id > 0 && data.toPort.id > 0) {
          if (data.fromPort.id != data.toPort.id) {
            let url = '/searchresult/' + data.fromPort.id + '/' + data.toPort.id + '/' + date + '/' + this.isSearch
            this.router.navigate([url]);
          }
          else {
            this.toastr.error("Port should be different.", "Error");
          }
        }
        else {
          this.toastr.error('Incurrect port', 'Erro');
        }

      }
    }
  }

  paginate(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.isSearch = false;
    this.getSearchResult();
  }

  paginatePort(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.SortByPortDetails();
  }

  paginatechepest(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    //this.SortbyChepestDetails();
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");

  }

  dateConvertSlider(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");

  }

  removeShips(ship) {
    if (ship != null) {
      if (this.selectedShipLines != null && this.selectedShipLines.length > 1) {
        const index: number = this.selectedShipLines.indexOf(ship);
        if (index !== -1) {
          this.selectedShipLines.splice(index, 1);
          this.shippingIds = '';
          this.selectedShipLines.forEach(element => {
            if (this.shippingIds == '') {
              this.shippingIds = element.shippingLineId.toString();
            }
            else {
              this.shippingIds = this.shippingIds + ',' + element.shippingLineId;
            }
          });
        }
        if (this.filterFlag == SearchBy.Port) {
          this.SortByPortDetails();
        }
        // else if (this.filterFlag == SearchBy.Cheapest) {
        //   this.currentPage = 1;
        //   this.isSearch = false;
        //   this.SortbyChepestDetails();
        // }
        else {
          this.currentPage = 1;
          this.isSearch = false;
          this.getSearchResult();
        }
      }
      else {
        this.toastr.info('You can not remove all Shipping lines', 'Info')
      }
    }
  }

  removeRegions(region) {
    if (region != null) {
      if (this.selectedRegion != null && this.selectedRegion.length > 1) {
        const index: number = this.selectedRegion.indexOf(region);
        if (index !== -1) {
          this.selectedRegion.splice(index, 1);
          this.regionIds = '';
          this.selectedRegion.forEach(element => {
            if (this.regionIds == '') {
              this.regionIds = element.regionId.toString();
            }
            else {
              this.regionIds = this.regionIds + ',' + element.regionId;
            }
          });
        }
        if (this.filterFlag == SearchBy.Port) {
          this.SortByPortDetails();
        }
        // else if (this.filterFlag == SearchBy.Cheapest) {
        //   this.currentPage = 1;
        //   this.isSearch = false;
        //   this.SortbyChepestDetails();
        // }
        else {
          this.currentPage = 1;
          this.isSearch = false;
          this.getSearchResult();
        }
      }
      else {
        this.toastr.info('You can not remove all Regions', 'Info')
      }
    }
  }


  // GetSliderarrivalandDep(fromportdatedep, toportarrival) {
  //   this.IsFilter = true;
  //   this.dateRange = this.createDateRange(fromportdatedep);
  //   this.valueArrival = this.dateRange[0].getTime();
  //   this.arroption = {
  //     stepsArray: this.dateRange.map((date: Date) => {
  //       return { value: date.getTime() };
  //     }),

  //     translate: (value: number, label: LabelType): string => {
  //       return new Date(value).toDateString();
  //     }
  //   };

  //   this.depselectedDate = this.createDepartureDateRange(toportarrival);
  //   this.valueDep = this.depselectedDate[0].getTime();
  //   this.OptionsDep = {
  //     stepsArray: this.depselectedDate.map((date: Date) => {
  //       return { value: date.getTime() };
  //     }),
  //     translate: (value: number, label: LabelType): string => {
  //       return new Date(value).toDateString();
  //     }

  //   };
  // }

  createSliderForDeparture(fromportdatedep) {
    this.IsFilter = true;
    this.dateRange = this.createDateRange(fromportdatedep);
    this.valueArrival = this.dateRange[0].getTime();
    this.arroption = {
      stepsArray: this.dateRange.map((date: Date) => {
        return { value: date.getTime() };
      }),
      translate: (value: number): string => {
        
        // this.fromPortSliderSelectedDate = this.dateConvert(new Date(value).toDateString());
        // return this.dateConvert(new Date(value).toDateString());
        this.fromPortSliderSelectedDate = this.dateConvertSlider(new Date(value).toDateString());
        return this.dateConvertSlider(new Date(value).toDateString());
      }
    };
  }

  createSliderForArrival(toportarrival) {
    this.depselectedDate = this.createDepartureDateRange(toportarrival);
    this.valueDep = this.depselectedDate[119].getTime();
    this.OptionsDep = {
      stepsArray: this.depselectedDate.map((date: Date) => {
        return { value: date.getTime() };
      }),
      translate: (value: number): string => {
        // this.toPortSliderSelectedDate = this.dateConvert(new Date(value).toDateString());
        // return this.dateConvert(new Date(value).toDateString());
        this.toPortSliderSelectedDate = this.dateConvertSlider(new Date(value).toDateString());
        return this.dateConvertSlider(new Date(value).toDateString());
      }
    };
  }

  createDateRange(arrdate): Date[] {
    const dates: Date[] = [];
    for (let i: number = 0; i < 120; i++) {
      let arrdate1 = new Date(arrdate);
      var dd = arrdate1.getDate() + i;
      var mm = arrdate1.getMonth();
      var y = arrdate1.getFullYear();
      dates.push(new Date(y, mm, dd));
    }
    this.toportarrivalladd30days = dates[29];
    return dates;
  }

  createDepartureDateRange(datedepport): Date[] {
    const dates: Date[] = [];
    for (let i: number = 0; i < 120; i++) {
      let arrdate1 = new Date(datedepport);
      var dd = arrdate1.getDate() + i;
      var mm = arrdate1.getMonth();
      var y = arrdate1.getFullYear();
      dates.push(new Date(y, mm, dd));
    }
    this.fromportarrivaladd30days = dates[29];
    return dates;
  }

  toPortChangeSlidder(val) {
    this.timeFlag = true;
    let date = new Date(val.value).toDateString();
    this.toPortSliderSelectedDate = this.dateConvert(date);
    if (this.filterFlag == SearchBy.Port) {
      this.SortByPortDetails();
    }
    // else if (this.filterFlag == SearchBy.Cheapest) {
    //   this.currentPage = 1;
    //   this.isSearch = false;
    //   this.SortbyChepestDetails(); 
    // }
    else {
      this.currentPage = 1;
      this.isSearch = false;
      this.getSearchResult();
    }

  }

  fromPortChangeSlidder(val) {
    this.timeFlag = true;
    let date = new Date(val.value).toDateString();
    this.fromPortSliderSelectedDate = this.dateConvert(date);
    if (this.filterFlag == SearchBy.Port) {
      this.SortByPortDetails();
    }
    // else if (this.filterFlag == SearchBy.Cheapest) {
    //   this.currentPage = 1;
    //   this.isSearch = false;
    //   this.SortbyChepestDetails();
    // }
    else {
      this.currentPage = 1;
      this.isSearch = false;
      this.getSearchResult();
    }
  }

  getDetails(id, fromDate, toDate) {
    if (id > 0 && (fromDate != null && fromDate != '') && (toDate != null && toDate != '')) {
      let fromdate = this.dateConvert(fromDate);
      let todate = this.dateConvert(toDate);
      var currentUser = localStorage.getItem('currentUser');
      if (currentUser != null && currentUser != undefined) {
        var url = '/' + 'voyagedetail' + '/' + id + '/' + this.stateParams.fromPortId + '/' + this.stateParams.toPortId + '/' + fromdate + '/' + todate;
        this.router.navigate([url]);
      }
      else {
        var voyageData = {
          id: id,
          page: 'voyagedetail',
          fromPortId: this.stateParams.fromPortId,
          toPortId: this.stateParams.toPortId,
          isTrashipment: 0,
          fromDate: fromdate,
          toDate: todate
        };
        localStorage.setItem('voyagedetailspage', JSON.stringify(voyageData));
        this.router.navigate(['/login']);
      }
    }
  }

  getTranshipmentVoyage(vesselsId, toVesselsId, midPortId, fromDate, toDate) {
    if (vesselsId > 0 && toVesselsId > 0 && midPortId > 0 && (fromDate != null && fromDate != '') && (toDate != null && toDate != '')) {
      let fromdate = this.dateConvert(fromDate);
      let todate = this.dateConvert(toDate);
      var currentUser = localStorage.getItem('currentUser');
      if (currentUser != null && currentUser != undefined) {
        var url = '/' + 'voyagedetail' + '/' + vesselsId + '/' + toVesselsId +
          '/' + this.stateParams.fromPortId + '/' + this.stateParams.toPortId + '/' + midPortId + '/' + 1 + '/' + fromdate + '/' + todate;
        // var url1 = '/' + 'voyagedetail' + '/' + vesselsId + '/' + this.stateParams.fromPortId + '/' + this.stateParams.toPortId + '/' + fromdate + '/' + todate;
        this.router.navigate([url]);
      }
      else {
        var voyageData = {
          id: vesselsId,
          toVesselsId: toVesselsId,
          page: 'voyagedetail',
          fromPortId: this.stateParams.fromPortId,
          toPortId: this.stateParams.toPortId,
          midPortId: midPortId,
          isTrashipment: 1,
          fromDate: fromdate,
          toDate: todate
        };
        localStorage.setItem('voyagedetailspage', JSON.stringify(voyageData));
        this.router.navigate(['/login']);
      }
    }
  }

  getPortDatafordropdown() {
    this.portService.GetPortData().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.portsData = response.content;
      }
    });
  }
  getSchedulerRouting(route) {
    if (route == 0 || route == 1) {
      this.scheduleRroute = route;
      this.gettransittimedetails();
      this.selectedShipLines = [];
      this.shippingIds = '';
      this.timeFlag = false;
      // create Departure Slider
      // this.createSliderForDeparture(this.stateParams.date);
      // create Departure Slider
      // this.createSliderForArrival(this.newDate);
      if (this.tap == SearchBy.Port) {
        this.currentPage = 1;
        this.isSearch = false;
        this.SortByPortDetails();
      }
      // else if (this.tap == SearchBy.Cheapest) {
      //   this.currentPage = 1;
      //   this.isSearch = false;
      //   this.SortbyChepestDetails();
      // }
      else {
        this.currentPage = 1;
        this.isSearch = false;
        this.getSearchResult();
      }
    }
  }
  filterByTranshipmentPorts(event) {
    if (event != null) {
      this.selectedTranshipmentPort = event.value;
      if (this.tap == SearchBy.Port) {
        this.currentPage = 1;
        this.isSearch = false;
        this.SortByPortDetails();
      }
      // else if (this.tap == SearchBy.Cheapest) {
      //   this.currentPage = 1;
      //   this.isSearch = false;
      //   this.SortbyChepestDetails();
      // }
      else {
        this.currentPage = 1;
        this.isSearch = false;
        this.getSearchResult();
      }
    }
  }

  getRateRequest(shipId) {
    if (shipId > 0 && this.stateParams.fromPortId > 0 && this.stateParams.toPortId > 0) {

      var currentUser = localStorage.getItem('currentUser');
      if (currentUser != null && currentUser != undefined) {
        var url = '/' + 'raterequest' + '/' + shipId + '/' + this.stateParams.fromPortId + '/' + this.stateParams.toPortId;
        this.router.navigate([url]);
      }
      else {
        var url = '/' + 'freightquotation' + '/' + shipId + '/' + this.stateParams.fromPortId + '/' + this.stateParams.toPortId;
        this.router.navigate([url]);
        // var rateRequestData = {
        //   page: 'freightquotation',
        //   fromPortId: this.stateParams.fromPortId,
        //   toPortId: this.stateParams.toPortId,
        //   shipsId: shipId
        // };
        // localStorage.setItem('raterequestpage', JSON.stringify(rateRequestData));
        // this.router.navigate(['/freightquotation']);
      }
    }
  }

  tracking(shipId, vesselsId, fromPortArrivalDate, isTranshipment) {
    if (this.stateParams != null && this.stateParams.fromPortId > 0 && this.stateParams.toPortId > 0) {
      if (shipId > 0 && vesselsId > 0 && (fromPortArrivalDate != null && fromPortArrivalDate != '')) {

        var fromDate = this.dateConvert(fromPortArrivalDate);
        var currentUser = localStorage.getItem('currentUser');
        if (currentUser != null && currentUser != undefined) {
          var url = '/' + 'tracking' + '/' + shipId + '/' + vesselsId + '/' + this.stateParams.fromPortId + '/' + this.stateParams.toPortId + '/' + fromDate;
          this.router.navigate([url]);
        }
        else {
          var trackingData = {
            page: 'tracking',
            fromPortId: this.stateParams.fromPortId,
            toPortId: this.stateParams.toPortId,
            shipsId: shipId,
            vesselId: vesselsId,
            DeptDate: fromPortArrivalDate
          };
          localStorage.setItem('trackingpage',JSON.stringify(trackingData));
          this.router.navigate(['/login']);
        }
      }
    }
  }
}